export default function currentTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
